import Axios from 'axios';

import { getSessionToken } from '@/utils/http';

const IS_DEV = import.meta.env.VITE_IS_DEV;

export const cpqAxios = Axios.create({
  baseURL: import.meta.env.VITE_CPQ_BACKEND_URL,
  headers: {
    'ngrok-skip-browser-warning': IS_DEV === 'true' ? true : false,
  },
});

cpqAxios.interceptors.request.use(
  async (config) => {
    const token = await getSessionToken();
    if (!token?.data) {
      return Promise.reject(
        new Error('Missing Monday session token for authenticated request.'),
      );
    }

    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token.data}`;
    return config;
  },
  (error) => Promise.reject(error),
);
